import React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { useState, useRef, useMemo } from 'react';
import JoditEditor from 'jodit-react';
import { useAddNewassetReqMutation } from '../../../features/assetrequest/assetReqApiSlice';
import { useGetUsersQuery } from '../../../features/users/usersApiSlice';
import useAuth from '../../../features/hooks/useAuth';
import { useGetofficesQuery } from '../../../features/offices/officesApiSlice';
import { useGetAssetsFinalQuery, useUpdateAssetintransitMutation } from '../../../features/addassets/addassetfinalApiSlice';
import EnhancedTable from './OffAssetTranReqTable'
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { useNavigate } from "react-router-dom";
import { HeadingWrap, Span, CommonButton } from '../../../Styles/CommonStyles'


const Container = styled.div``
const Wrapper = styled.div``
const RequestWrapper = styled.div``
const IntRequestWrapper = styled.div``
const SelectContainer = styled.div`
display: flex;
align-items: center;
margin-bottom: 25px;
margin-top: 25px;
`
const TextInputWrap = styled.div`
height: 30vh;
`
const SubmitButton = styled(CommonButton)`
`
const OffAssetTransReq = () => {
    const [content, setContent] = useState('');
    const editor = useRef(null);
    const [selectedUserId, setSelecteduserId] = useState()

    //created hook to pass data from ofcassettable to parent
    const [intSelected, setIntSelected] = useState([])

    //logged in user data
    const { id, email, designation, designationSuffix, numSuffix, roles } = useAuth()
    let user_current_office = (useSelector((state) => state.office.off))
    let user_current_role_array = roles[user_current_office]

    // all users call 
    const {
        data: usersdata,
        isLoading: usersLoading,

    } = useGetUsersQuery('userslist', {
        refetchOnFocus: true,
        refetchOnMountOrArgChange: true
    });

    let users = usersdata ? Object.values(usersdata?.entities) : []

    //usercall/single user call
    const { getSingleuser } = useGetUsersQuery('userslist', {
        selectFromResult: ({ data }) => ({
            getSingleuser: data?.entities
        }),
    })

    // filter users with current office:
    let allOfficeUsers = users.filter(elm => (elm.office.mainCharge === user_current_office) || (elm.office.additionalCharge.includes(user_current_office)))

    // filter this existing user
    let officeUsers = allOfficeUsers?.filter(elm => elm._id !== id)

    //add mutation call
    const [addNewRequest, { isLoading: addNewRequestloading }] = useAddNewassetReqMutation()

    // I think intransit state of the assets may be kept intact
    //assets in transit status update call 
    const [updateAssetinTran, { isLoading: updateAssetinTranloading }] = useUpdateAssetintransitMutation()

    //in transit body 
    // it will work for only those which are with office but not in transit
    // all assets call
    const {
        data: allassets,
        isLoading,
        isSuccess,
        isError,
        error
    } = useGetAssetsFinalQuery('allassetlist', {
        refetchOnFocus: true,
        refetchOnMountOrArgChange: true
    });

    let allassetdata = allassets ? Object.values(allassets?.entities) : []
    let allAssets = allassetdata || []

    // filter assets with current user office and not in transit
    let officeAssetsnotintransit = allAssets?.filter(elm => (elm.alloc_ofc === user_current_office) && (!elm.in_transit))

    let selectedAssetarray = officeAssetsnotintransit

    let assetTranBody = { selectedAssetarray: selectedAssetarray, transtatus: true }

    // create sending userobject
    let sendUserObj = { id: selectedUserId, name: getSingleuser && getSingleuser[selectedUserId]?.name, office: user_current_office, designation: getSingleuser && getSingleuser[selectedUserId]?.designation[user_current_office], designationSuffix: getSingleuser && getSingleuser[selectedUserId]?.designationSuffix[user_current_office], numSuffix: getSingleuser && getSingleuser[selectedUserId]?.numSuffix[user_current_office] }

    //************************************************************************ */
    //create a unique Id
    const uniqueReqID = () => {
        const dateString = Date.now().toString(36);
        const emailofuser = getSingleuser && getSingleuser[id]?.email?.slice(0, -8)
        const uid = `${emailofuser}-${dateString}`
        return uid;
    };
    let uniqueReqId = uniqueReqID()

    //**************************************************************************** */
    let userReqData = {
        uniqueReqId: uniqueReqId,
        req_type: 'ofc_asset_Trans',
        req_cat: 'byBotoUser',
        req_creator: { id: id, name: getSingleuser && getSingleuser[id]?.name, office: user_current_office, designation: designation[user_current_office], designationSuffix: designationSuffix[user_current_office], numSuffix: numSuffix[user_current_office] },
        req_store: '',
        sent_to_tag: 'user',
        curr_status: 'pending',
        created_at: new Date(),
        curr_sent_by: { id: id, name: getSingleuser && getSingleuser[id]?.name, office: user_current_office, designation: designation[user_current_office], designationSuffix: designationSuffix[user_current_office], numSuffix: numSuffix[user_current_office] },
        curr_sent_to: sendUserObj,
        req_data: [{
            //save all assets (as we have to transfer entire assets with office these will include all the assets in which some are already in transit with some request and some will not be in transit )
            assets_details: intSelected,
            //save assets which are not in transit at the time of request so that only these assets status can be changed and other assets which were already in transit can be remain intact.
            non_transit_assets: officeAssetsnotintransit,
            Text: content,
            sent_by: { id: id, name: getSingleuser && getSingleuser[id]?.name, office: user_current_office, designation: designation[user_current_office], designationSuffix: designationSuffix[user_current_office], numSuffix: numSuffix[user_current_office] },
            sent_to: sendUserObj,
            status: 'pending',
            time_stamp: new Date()
        }]
    }

    const navigate = useNavigate();
    const handleReqSubmit = async () => {
        if (selectedUserId) {
            try {
                await addNewRequest(userReqData).unwrap()

                // await updateAssetinTran(assetTranBody)
                navigate('/management/assets/bo')
                return alert('your request is forwarded to the selected user')

            } catch (err) {
                return alert(`Error:${err}`)
            }
        } else {
            return alert('Please register the user')
        }
    }

    let userOptions = officeUsers?.map(elm => { return { title: `${elm.name.firstName} ${elm.name.middleName} ${elm.name.lastName}-(${elm.designation[user_current_office]})`, value: elm._id } })

    return (
        <Container>
            <Wrapper>
                <RequestWrapper>
                    <IntRequestWrapper><EnhancedTable setIntSelected={setIntSelected} /></IntRequestWrapper>
                    <TextInputWrap>
                        <HeadingWrap>
                            <Span>Details/Justifications</Span>
                        </HeadingWrap>
                        <JoditEditor
                            ref={editor}
                            value={content}
                            onBlur={newContent => setContent(newContent)}
                            onChange={newContent => { }}
                        />
                    </TextInputWrap>
                    <HeadingWrap>
                        <Span>Select User</Span>
                    </HeadingWrap>
                    <SelectContainer>
                        <Autocomplete
                            id="combo-box-demo"
                            options={userOptions}
                            sx={{ width: 600 }}
                            value={selectedUserId}
                            onChange={(event, newValue) => {
                                if (newValue) {
                                    // Set the selected value in state
                                    setSelecteduserId(newValue.value);
                                } else {
                                    // Handle case when no option is selected
                                    setSelecteduserId(null);
                                }
                            }}
                            getOptionLabel={(option) => option.title}
                            renderInput={(params) => <TextField {...params} label="Select user for handing over the office Assets" />}
                        />
                    </SelectContainer>
                </RequestWrapper>
                <SubmitButton onClick={handleReqSubmit}>Sent to the selected users</SubmitButton>
            </Wrapper>
        </Container>
    )
}

export default OffAssetTransReq